// extracted by mini-css-extract-plugin
export default {"container":"AddFood_container__o9Q2S"};